import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  SegmentedView,
  SegmentedViewController,
  SegmentedViewData,
} from '../../../components/SegmentedViewController';
import useGetDriverLookup from '../../../hooks/dashboard/driver-lookup/useGetDriverLookup';
import { DRIVER_LOOKUP_INFO, LOOKUP } from '../../../routes/routeConstants';
import DriverLookupBioArea from './DriverLookupBioArea';
import DriverLookupDataBreakdown from './DriverLookupDataBreakdown';
import PerformanceMetrics from './PerformanceMetrics';

const segmentedViewControllerTitle = [
  { title: 'Overview' },
  { title: 'Performance Metrics' },
];

const DriverLookupInfo = () => {
  const { jsonData } = useParams();

  const { ninNumber } = useParams();
  const location = useLocation();
  const { getDriverLookup } = useGetDriverLookup();

  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);
  const navigationData = location?.state?.data;
  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;

  useEffect(() => {
    if (navigationData) {
      getDriverLookup(navigationData?.ninNumber, DRIVER_LOOKUP_INFO, () => {});
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Look Up`,
        link: `/${LOOKUP}`,
      },
      {
        name: `Results for NIN: ${ninNumber}`,
        link: `/${DRIVER_LOOKUP_INFO}/${ninNumber}/${encodeURIComponent(JSON.stringify(objectFyData))}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Look Up Information'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <HeaderArea>
            <Header>Look Up</Header>
            <DriverLookupBioArea />
          </HeaderArea>

          {/*  */}
          <SegmentControlArea>
            <SegmentedView>
              <SegmentedViewController
                segmentedViewControllerTitle={segmentedViewControllerTitle}
              />
              <SegmentedViewData>
                <section>
                  <DriverLookupDataBreakdown ninNumber={ninNumber} />
                </section>
                <section>
                  <PerformanceMetrics />
                </section>
              </SegmentedViewData>
            </SegmentedView>
          </SegmentControlArea>
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverLookupInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
`;

const SegmentControlArea = styled.div`
  display: flex;
`;
